import { useState } from 'react';
import { UserRound } from 'lucide-react';

// Avatar circular con fallback coherente: si no hay imagen o falla la carga
// (signed URL expirada, objeto faltante, error de red), muestra la inicial del
// nombre o un icono de usuario. Evita los "círculos negros" al romperse un <img>.
export default function Avatar({ src, name, iconClassName = 'w-10 h-10 text-muted-foreground', initialClassName = 'font-heading font-bold text-lg' }) {
  const [failed, setFailed] = useState(false);

  if (src && !failed) {
    return (
      <img
        src={src}
        alt=""
        className="w-full h-full object-cover"
        onError={() => setFailed(true)}
        loading="lazy"
      />
    );
  }

  const initial = (name || '').trim()[0]?.toUpperCase();
  if (initial) {
    return (
      <div className="w-full h-full flex items-center justify-center bg-muted text-foreground">
        <span className={initialClassName}>{initial}</span>
      </div>
    );
  }

  return (
    <div className="w-full h-full flex items-center justify-center bg-muted">
      <UserRound className={iconClassName} />
    </div>
  );
}
